<div class="info-popup info-popup--success" [attr.role]="notification.role" [attr.aria-live]="notification.ariaLive">
    <!-- <div class="info-popup__close">
        <span class="icon icon-mobile-delete"></span>
    </div> -->
    <div class="info-popup__type">
        <!--<span class="info-popup__icon icon icon-success"></span>-->
        <img
            class="info-popup__icon icon icon-success dark:filter-yellow"
            src="assets/icon_notification_success.svg"
            alt="" />
    </div>
    <div class="info-popup__title">
        {{ title | translate }}
    </div>
    <div class="info-popup__text">
        <ng-container *ngIf="notification.translate">
            {{ message | translate }}
        </ng-container>
        <ng-container *ngIf="!notification.translate">
            <ng-container
                *ngIf="
                    notification.translations.length > 0 && (notification | translateObjectField : 'message' : locale)
                ">
                {{ notification | translateObjectField : 'message' : locale }}
            </ng-container>
            <ng-container
                *ngIf="
                    notification.translations.length > 0 && !(notification | translateObjectField : 'message' : locale)
                ">
                {{ notification.message ? notification.message : '' }}
            </ng-container>
            <ng-container *ngIf="notification.translations.length === 0">
                {{ notification.message }}
            </ng-container>
        </ng-container>
    </div>
</div>
